import React from "react";
import "@/i18n/config";

// The i18n engine is now powered by react-i18next (see ./config.js).
// This provider is kept as a thin wrapper so the app tree has a single
// place to initialise/extend localisation if needed.
export const I18nProvider = ({ children }) => {
  return <>{children}</>;
};

export default I18nProvider;
